export const PROPERTIES = new Set([
    'version',
    'prodid',
    'calscale',
    'method',
    'name',
    'refresh-interval',
    'source',
    'color',
    'image',
    'conference',
    'attach',
    'categories',
    'class',
    'comment',
    'description',
    'geo',
    'location',
    'percent-complete',
    'priority',
    'resources',
    'status',
    'summary',
    'completed',
    'dtend',
    'due',
    'dtstart',
    'duration',
    'freebusy',
    'transp',
    'tzid',
    'tzname',
    'tzoffsetfrom',
    'tzoffsetto',
    'tzurl',
    'attendee',
    'contact',
    'organizer',
    'recurrence-id',
    'related-to',
    'url',
    'uid',
    'exdate',
    'exrule',
    'rdate',
    'rrule',
    'action',
    'repeat',
    'trigger',
    'created',
    'dtstamp',
    'last-modified',
    'sequence',
    'request-status',
]);

export const UNIQUE_PROPERTIES = new Set([
    'id',
    'uid',
    'dtstamp',
    'class',
    'created',
    'description',
    'geo',
    'last-modified',
    'recurrence-id',
    'location',
    'organizer',
    'priority',
    'sequence',
    'status',
    'summary',
    'transp',
    'trigger',
    'action',
    'url',
    'rrule',
    'dtstart',
    'dtend',
    'duration',
    'repeat',
    'attach',
    'due',
    'tzid',
    'prodid',
    'x-wr-calname',
    'x-wr-timezone',
    'x-pm-session-key',
    'x-pm-shared-event-id',
    'x-pm-proton-reply',
    'x-pm-conference-id',
    'x-pm-conference-url',
    'x-yahoo-yid',
    'x-yahoo-user-status',
    'version',
    'calscale',
    'method',
    'refresh-interval',
    'color',
]);
